const SEARCH_PREFIX = '@SEARCH';

export const FETCH = `${SEARCH_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${SEARCH_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${SEARCH_PREFIX}/FETCH_ERROR`;

export const RESET_QUERY = `${SEARCH_PREFIX}/RESET_QUERY`;

export const LOAD_EXTRA_ITEMS = `${SEARCH_PREFIX}/LOAD_EXTRA_ITEMS`;
export const LOAD_EXTRA_SUCCESS = `${SEARCH_PREFIX}/LOAD_EXTRA_SUCCESS`;
export const LOAD_EXTRA_ERROR = `${SEARCH_PREFIX}/LOAD_EXTRA_ERROR`;
export const LOAD_EXTRA_COMPLETED = `${SEARCH_PREFIX}/LOAD_EXTRA_COMPLETED`;
